export function Footer() {
  return (
    <footer className="bg-white text-gray-600 py-12 border-t border-gray-200">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[140px]">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* NEXSENS Logo & Info */}
          <div>
            <img 
              src="/images/Layer_1.png" 
              alt="NEXSENS Technology" 
              className="max-w-[100%] mb-3"
            />
            <p className="text-base text-gray-500">Water monitoring solutions since 1989</p>
          </div>

          {/* Buy Column */}
          <div>
            <h4 className="text-[#4D4D4D] font-bold mb-3 text-xl">Buy</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Sensors</a></li>
              <li><a href="#" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Systems</a></li>
            </ul>
          </div>

          {/* Learn Column */}
          <div>
            <h4 className="text-[#4D4D4D] font-bold mb-3 text-xl">Learn</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Help Center</a></li>
              <li><a href="#" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Measurements Handbook</a></li>
            </ul>
          </div>

          {/* Policy Column */}
          <div>
            <h4 className="text-[#4D4D4D] font-bold mb-3 text-xl">Policy</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Terms of Service</a></li>
              <li><a href="#" className="text-base text-[#4D4D4D] hover:text-gray-900 transition">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-base text-gray-500">
            <p>© 2025 Nexsens Technologies, Inc. | Questions? Call 937.426.2703 or email <a href="mailto:info@nexsens.com" className="text-[#4D4D4D] hover:text-gray-900 transition">info@nexsens.com</a></p>
          </div>
        </div>
      </div>
    </footer>
  )
}
